import axios from "axios";

const BACKEND_URL = "https://caflow.fastapicloud.dev";
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API_BASE,
    headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("ca_access_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            const url = err?.config?.url || "";
            if (!url.includes("/auth/")) {
                localStorage.removeItem("ca_access_token");
                localStorage.removeItem("ca_refresh_token");
                if (window.location.pathname !== "/login") {
                    window.location.assign("/login");
                }
            }
        }
        return Promise.reject(err);
    },
);

export function formatApiError(err) {
    const d = err?.response?.data?.detail;
    if (!d) return err?.message || "Something went wrong.";
    if (typeof d === "string") return d;
    if (Array.isArray(d))
        return d
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    if (typeof d === "object" && typeof d.msg === "string") return d.msg;
    return String(d);
}

export default api;
